<template>
    <div class="biz-house-map-card-m">
        <modal class="delete-house" :display="modalStatus.deleteHouse" @modalStatus="closeModal('deleteHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除房源</h1>
            <div class="content">
                確定刪除“{{house?house.houseName:'房源名稱'}}”的房源嗎？<br>記錄刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteHouse(house.cid)">確認</button>
                <button class="border-button" @click="closeModal('deleteHouse')">取消</button>
            </div>
        </modal>
        <modal class="alarm-orange" :display="modalStatus.editHouse" @modalStatus="closeModal('editHouse')" >
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_orange.svg" alt="">
            <h1>無法上架</h1>
            <div class="content">
                目前有進行中的合約，請先更新最快起租日
            </div>
            <div class="btn-group">
                <button class="default-button" @click="$router.push({name: 'bizEditHouse', query: {'cid': house.cid}})">編輯房源</button>
            </div>
        </modal>
        <div class="biz-house-map-card" :class="{'rented': !house.empty}" :data-id="house.cid" :data-district="house.district" @click.stop="clickEvent" @mouseenter="changeAddressIcon(), findMarker()" @mouseleave="changeAddressIcon">
            <div class="biz-house-map-card-wrap">
                <div v-if="house.coverImage" class="house-image">
                    <img :src="imageUrl(house.coverImage)" alt="">
                </div>
                <div v-else class="house-image">
                    <img src="@/assets/img/component/houseCard/default.jpg" alt="">
                </div>
                <div class="content-wrap">
                    <div class="biz-house-map-card-title">
                        {{house.houseName}}
                    </div>
                    <div class="biz-house-map-card-address">
                        {{house.address}}
                    </div>
                    <!-- <img id="address-icon" :src="addressIcon"  @click.stop="setHouseCenter({lat: house.lat, lng: house.lng})" alt=""> -->
                    <div class="biz-house-map-card-price" v-if="price">
                        ${{price}}
                    </div>
                    <div class="house-map-btn-group">
                        <div class="house-state">
                            <span v-if="house.publish" class="put">上架</span>
                            <span v-else class="off">下架</span>
                            <span v-if="house.complete" class="completed">完善</span>
                            <span v-else class="uncompleted">未完善</span>
                        </div>
                        <dot-dropmenu>
                            <ul >
                                <li v-if="bizAuth.onOrOffShelf.hasRight && house.complete && !house.publish" @click="setBizHousePublish({houseCid: house.cid, status:'REVEAL'})">上架</li>
                                <li v-if="bizAuth.onOrOffShelf.hasRight && house.publish" @click="setBizHousePublish({houseCid: house.cid, status:'HIDE'})">下架</li>
                                <li v-if="bizAuth.shareHouse.hasRight && house.complete && house.publish" @click="shareHouse(house.cid)">分享</li>
                                <li v-if="bizAuth.previewHouse.hasRight" @click="previewHouse(house.cid)">預覽</li>
                                <li v-if="bizAuth.deleteHouse.hasRight" @click="openModal('deleteHouse')">刪除</li>
                                <!-- <li>檢舉平反(待確認)</li>
                                <li>更新時間(待確認)</li>
                                <li>複製廣告(待確認)</li> -->
                            </ul>
                        </dot-dropmenu>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'
import {
    apiBizPublishHouse
} from "@/apis/api.js";

export default {
    name: 'HouseCard',
    data () {
        return {
            addressIcon: require('@/assets/img/icon/address_green_border.svg'),
            modalStatus:{
                deleteHouse: false,
                editHouse: false
            },
        }
    },
    props:{
        house: ''
    },
    methods: {
        setBizHousePublish: function (data) {
            if(data.status === 'REVEAL' && !this.house.publishAvailable){
                this.openModal('editHouse')
                return false
            }

            apiBizPublishHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('getBizHouseMgtList')
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})

                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        openModal: function (type) {
            if(type == 'deleteHouse'){
                if(this.house.arrears){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得刪除',type: 'error', closeBtn: true})
                }else{
                    this.modalStatus.deleteHouse = true
                }
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = true
            }
        },
        closeModal: function (type) {
            if(type == 'deleteHouse'){
                this.modalStatus.deleteHouse = false
            }else if(type == 'editHouse'){
                this.modalStatus.editHouse = false
            }
        },
        shareHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('分享房源', { screen_name: '分享房源'})
            this.$store.commit('bizHouseManagement/set_selected_house_cid', houseCid)
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizShareSocialMedia'})
        },
        previewHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('預覽房源', { screen_name: '預覽房源'})
            let routeData = this.$router.resolve({name: 'previewHouse', query: {cid: houseCid}});
            window.open(routeData.href, '_blank');
        },
        deleteHouse: function (houseCid) {
            this.$analyticsBiz.logEvent('刪除房源', { screen_name: '刪除房源'})
            this.$store.dispatch('deleteBizEditHouse', houseCid)
            .then( () => {
                this.$store.dispatch('getBizHouseMgtList')
            });
        },
        changeAddressIcon: function () {
            if( event.type == 'mouseenter' ){
                this.addressIcon = require('@/assets/img/icon/address_pink.svg')
            }else if( event.type == 'mouseleave' ){
                this.addressIcon = require('@/assets/img/icon/address_green_border.svg')
            }
        },
        // hover找尋地圖標記,改變顏色
        findMarker: function () {
            // console.log(event.target.dataset.district)
            let houseDistrict = event.target.dataset.district,
                houseId = event.target.dataset.id,
                districts = document.querySelectorAll('.district'),
                clusters = document.querySelectorAll('.custom-clustericon')

            if( districts.length > 0 ){
                for (let i = 0; i < districts.length; i++) {
                    const district = districts[i];
                    if( houseDistrict == district.dataset.district ){
                        district.style.background = '#f5a623'
                    }else{
                        district.style.background = '#ff9275'
                    }
                }
            }
            if( clusters.length > 0 ){
                for (let i = 0; i < clusters.length; i++) {
                    const cluster = clusters[i];

                    // console.log(cluster.title.match(houseId))
                    if(cluster.title.match(houseId)){
                        cluster.style.background = '#f5a623'
                    }else{
                        cluster.style.background = '#ff9275'
                    }

                }
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clickEvent: function (){
            // 權限導頁
            if(this.bizAuth.editHouse.hasRight){
                // 編輯權限
                if(this.house.locked){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '預定中不可編輯',type: 'error', closeBtn: true})
                }else if(this.house.arrears){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得刪除',type: 'error', closeBtn: true})
                }else{
                    this.$router.push({name: 'bizEditHouse', query: {'cid': this.house.cid}})
                }
            }else{
                // 查看權限
                this.$router.push({name: 'bizViewHouse', query: {'cid': this.house.cid}})
            }
        },
        setHouseCenter: function (latlng) {
            // console.log(latlng)
            //todo
            this.$store.commit('bizHouseManagement/set_filter_query_county', this.house.county)
            this.$store.commit('bizHouseManagement/set_fiter_query_district', this.house.district)
            this.$store.commit('bizHouseManagement/set_house_marker_center', latlng)

        },
        imageUrl: function (url){
            return constant.imageUrl+url
        }
    },
    computed: {
        price: function () {
            return this.toCurrency(this.house.rentPrice)
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal
    }
}
</script>
<style lang="scss" scoped>
    .biz-house-map-card-m{
        #modal.delete-house{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .biz-house-map-card{
            position: relative;
            width: 352px;
            // height: 96px;
            background: #fff;
            margin: 0 24px;
            padding: 20px 0px;
            border-bottom: 1px solid #f3f3f3;
            .biz-house-map-card-wrap{
                display: flex;
                align-items: center;
                // .house-state{
                //     position: absolute;
                //     width: 26px;
                //     height: 26px;
                //     right: 20px;
                //     top: 20px;
                //     display: flex;
                //     align-items: center;
                //     justify-content: center;
                //     border-radius: 4px;
                //     background-color: #cacfcd;
                //     color: #fff;
                //     font-size: 12px;
                // }
                .house-image{
                    width: 128px;
                    height: 96px;
                    border-radius: 4px;
                    margin-right: 16px;
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
                .content-wrap{
                    width: 212px;
                    .biz-house-map-card-title{
                        font-size: 20px;
                        margin-bottom: 10px;
                    }
                    .biz-house-map-card-address{
                        width: 176px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        font-weight: 300;
                        margin-bottom: 11px;
                    }
                    #address-icon{
                        cursor: pointer;
                        position: absolute;
                        right: -4px;
                        bottom: 52px;
                    }
                    .biz-house-map-card-price{
                        font-size: 16px;
                        font-weight: 500;
                        margin-bottom: 8px;
                    }
                    .house-map-btn-group{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .house-state{
                            position: relative;
                            display: flex;
                            align-items: center;
                            span{
                                width: 52px;
                                height: 26px;
                                background-color: #cacfcd;
                                color: #fff;
                                font-size: 12px;
                                border-radius: 4px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                            span.put{
                                background-color: rgba(113, 170, 229, 0.1);
                                color: #71aae5;
                                margin-right: 8px;
                            }
                            span.off{
                                background-color: #f3f3f3;
                                color: #676362;
                                margin-right: 8px;
                            }
                            span.completed{
                                background-color: #71aae5;
                            }
                            span.uncompleted{
                                background-color: #ff9275;
                            }
                        }
                    }
                }
            }

        }
        // @media screen and (max-width: 1280px) {
        //     .biz-house-map-card{
        //         width: 270px;
        //         .biz-house-map-card-wrap{
        //             .house-image{
        //                 display: none;
        //             }
        //             .content-wrap{
        //                 padding: 11px 0px;
        //                 .biz-house-map-card-address{
        //                     width: 220px;
        //                 }
        //             }
        //         }
        //     }

        // }
        // .biz-house-map-card.rented{
        //     // border: solid 1px #525956;
        //     .biz-house-map-card-wrap{
        //         .house-state{
        //             background-color: #525956;
        //         }
        //     }
        // }
        // .biz-house-map-card:hover{
        //     background: #ff9275;
        //     // border: solid 1px #ff9275;
        //     .biz-house-map-card-wrap{
        //         .house-state{
        //              background-color: rgba(255, 255, 255, 0.2);
        //         }
        //         .content-wrap{
        //             .biz-house-map-card-title{
        //                 color: #fff;
        //             }
        //             .biz-house-map-card-address{
        //                 color: #fff;
        //             }
        //             .biz-house-map-card-price{
        //                 color: #fff;
        //             }
        //         }
        //     }
        // }
    }

</style>



// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapHouseCard.vue